/**
 * KORVN — QLI per-order quantity limits on product forms (snippets/korvn-qli-qty-max.liquid).
 * Inputs with data-korvn-qli-max are clamped on input/change and right before any click in their
 * product form (Add to cart, Buy it now, accelerated checkout), so an online checkout never starts
 * with more units than checkout can rate. The theme can rewrite `max` after a cart update, so the
 * data attribute is the source of truth.
 */
(function () {
  if (window.korvnQliLimits) return;
  window.korvnQliLimits = true;
  function clamp(el) {
    var max = parseInt(el.getAttribute('data-korvn-qli-max'), 10);
    if (!max) return;
    el.max = max;
    var v = parseInt(el.value, 10);
    if (v > max) {
      el.value = max;
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  function clampAll() {
    document.querySelectorAll('input[data-korvn-qli-max]').forEach(clamp);
  }
  document.addEventListener('input', function (e) { if (e.target.matches && e.target.matches('input[data-korvn-qli-max]')) clamp(e.target); }, true);
  document.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('input[data-korvn-qli-max]')) clamp(e.target); }, true);
  document.addEventListener('click', clampAll, true);
  document.addEventListener('submit', clampAll, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', clampAll); else clampAll();
})();
